export type anyFn = (...args: unknown[]) => void;
export const forkFn = (originFn: anyFn | undefined, forkedFn: anyFn): anyFn => {
    return (...args: unknown[]) => {
        if (originFn !== undefined) {
            originFn(...args);
        }

        forkedFn(...args);
    };
};
